/** Français */
export default {
  common: {
    loading: 'Chargement…',
    loadingProject: 'Chargement du projet…',
    cancel: 'Annuler',
    optional: '(facultatif)',
    you: 'vous',
    dash: '—',
    serverError: 'Erreur {{status}}',
  },
  lang: {
    label: 'Langue',
  },
  nav: {
    projects: 'Projets',
    tecnico: 'Bureau technique',
    admin: 'Administration',
    logout: 'Se déconnecter',
  },
  roles: {
    USER: 'Utilisateur',
    TECNICO: 'Technicien',
    ADMIN: 'Admin',
    badgeAdmin: 'admin',
    badgeTecnico: 'technicien',
  },
  craneType: {
    CINGOLATA: 'Grue sur chenilles',
    RAGNO: 'Grue araignée',
    AUTOCARRATA: 'Grue sur camion',
    TORRE: 'Grue à tour',
  },
  login: {
    titleLogin: 'Connexion au configurateur',
    titleRegister: 'Créer un compte',
    subtitle: 'Configurateur 3D de grues BGLift',
    name: 'Nom',
    email: 'Email',
    password: 'Mot de passe',
    submitLogin: 'Se connecter',
    submitRegister: "S'inscrire",
    toggleToRegister: "Pas encore de compte ? S'inscrire",
    toggleToLogin: 'Vous avez déjà un compte ? Se connecter',
  },
  dashboard: {
    title: 'Vos projets',
    subtitle: 'Configurations de levage enregistrées',
    newProject: '+ Nouveau projet',
    empty: 'Aucun projet pour le moment : créez-en un pour commencer à configurer la grue.',
    createFirst: 'Créer le premier projet',
    byUser: 'par {{name}}',
    updated: 'Mis à jour le {{date}}',
    certificatePdf: 'Certificat PDF',
    resend: 'Renvoyer pour validation',
    sendForReview: 'Envoyer au bureau technique pour validation',
    openConfigurator: 'Ouvrir le configurateur',
    deleteTitle: 'Supprimer le projet',
    confirmDelete: 'Supprimer le projet « {{name}} » ?',
    modalTitle: 'Nouveau projet',
    modalSubtitle: 'Choisissez le type et le modèle de grue : vous la configurerez dans la scène 3D.',
    projectName: 'Nom du projet',
    projectNamePlaceholder: 'Ex. Chantier Via Roma',
    craneType: 'Type de grue',
    selectType: 'Sélectionnez le type…',
    model: 'Modèle',
    selectModel: 'Sélectionnez le modèle…',
    createProject: 'Créer le projet',
    creating: 'Création…',
  },
  configurator: {
    backToProjects: 'Retour aux projets',
    back: 'Projets',
    savedAt: 'Enregistré à {{time}}',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
  },
  tecnico: {
    title: 'Bureau technique',
    subtitle: 'Demandes de validation de configuration des clients',
    empty: 'Aucune demande en attente. Les nouvelles demandes des clients apparaîtront ici.',
    requestedBy: 'Demande de {{name}} ({{email}}) · envoyée le {{date}}',
    assignedTo: 'Attribuée à {{name}}',
    openConfiguration: 'Ouvrir la configuration',
    claim: 'Prendre en charge',
    certify: 'Joindre le PDF et certifier',
    certifying: 'Téléversement…',
  },
  admin: {
    title: 'Administration',
    subtitle: 'Gestion des utilisateurs et du catalogue de modèles de grues',
    tabUsers: 'Utilisateurs',
    tabModels: 'Modèles de grues',
  },
  users: {
    newUser: '+ Nouvel utilisateur',
    colUser: 'Utilisateur',
    colRole: 'Rôle',
    colStatus: 'Statut',
    colProjects: 'Projets',
    colActions: 'Actions',
    active: 'Actif',
    inactive: 'Désactivé',
    resetPassword: 'Réinitialiser le mot de passe',
    deactivate: 'Désactiver',
    reactivate: 'Réactiver',
    delete: 'Supprimer',
    modalTitle: 'Nouvel utilisateur',
    name: 'Nom',
    email: 'Email',
    password: 'Mot de passe',
    role: 'Rôle',
    createUser: "Créer l'utilisateur",
    creating: 'Création…',
    promptResetPassword: 'Nouveau mot de passe pour {{email}} (min. 6 caractères) :',
    passwordUpdated: 'Mot de passe mis à jour.',
    confirmDelete: 'Supprimer définitivement {{email}} ? Ses {{count}} projets seront également supprimés.',
  },
  models: {
    newModel: '+ Nouveau modèle',
    colCode: 'Code',
    colName: 'Nom',
    colType: 'Type',
    colFile3d: 'Fichier 3D',
    colProjects: 'Projets',
    colStatus: 'Statut',
    colActions: 'Actions',
    active: 'Actif',
    inactive: 'Désactivé',
    deactivate: 'Désactiver',
    activate: 'Activer',
    delete: 'Supprimer',
    confirmDelete: 'Supprimer le modèle {{code}} ?',
    modalTitle: 'Nouveau modèle de grue',
    modalSubtitle:
      'Vous avez besoin du fichier 3D (.glb) et du fichier JSON avec les données techniques (géométrie, tableau de charge, configuration par défaut — même structure que BR0089.json).',
    code: 'Code',
    codePlaceholder: 'Ex. BR0100',
    craneType: 'Type de grue',
    name: 'Nom',
    namePlaceholder: 'Ex. BGLift BR0100',
    description: 'Description',
    file3d: 'Fichier 3D (.glb)',
    dataFile: 'Données techniques (.json)',
    createModel: 'Créer le modèle',
    creating: 'Téléversement…',
  },
  controls: {
    realtimeCalc: 'Calcul de capacité en temps réel',
    reset: 'Réinitialiser',
    resetField: 'Réinitialiser',
    restore: 'Restaurer',
    legFrontLeft: 'Avant gauche',
    legFrontRight: 'Avant droit',
    legRearLeft: 'Arrière gauche',
    legRearRight: 'Arrière droit',
    groupLoad: 'Charge',
    loadWeight: 'Poids levé',
    maxSwl: 'Capacité max (SWL)',
    loadUtil: 'Utilisation de charge',
    groupAerial: 'Groupe aérien',
    boom: 'Flèche',
    angle: 'Angle',
    extensionStroke: "Course d'extension",
    borePressure: 'Pression côté fond',
    rodPressure: 'Pression côté tige',
    turretRotation: 'Rotation de la tourelle',
    workRadius: 'Rayon de travail',
    jib: 'Jib',
    jibAngle: 'Angle du jib',
    groupGround: 'Groupe au sol',
    opening: 'Ouverture',
    footHeight: 'Hauteur du pied',
    knee: 'Genou',
    groundHelp:
      "Ouverture et Genou ont des positions fixes (trous sur la machine), réglables stabilisateur par stabilisateur : ouverture 0° = repliée le long du châssis, {{deg}}° = entièrement ouverte ; genou 0° = tibia en position de conception. Hauteur du pied : 0 = pied au sol, valeurs positives = pied sur un appui plus haut (restant appuyé et porteur). Les réactions utilisent les positions réelles des pieds calculées à partir de l'ouverture, du genou et de la hauteur du pied (géométrie issue du plan BGLift) ; les masses de la machine restent indicatives.",
    disclaimer:
      "Prototype avec des données SWL indicatives. Toujours valider par rapport au tableau officiel BGLift et à la norme EN 13000 avant utilisation sur chantier.",
  },
  status: {
    safe: 'SÉCURISÉ',
    warning: 'ATTENTION',
    critical: 'CRITIQUE — STOP',
    shortSafe: 'OK',
    shortWarning: 'ATT.',
    shortCritical: 'STOP',
    calculating: 'Calcul en cours…',
    radius: 'Rayon',
    swl: 'SWL',
    loadUtil: 'Util. charge',
    padUtil: 'Util. patin max',
    tippingMargin: 'Marge de basculement',
    en13000: 'EN 13000 — basculement à 0 % · seuil d’attention à 20 %',
    controls: 'Commandes',
  },
  review: {
    requested: 'Envoyée au bureau technique',
    inReview: 'Prise en charge par le bureau technique',
    certified: 'Configuration certifiée',
    certificatePdf: 'Certificat PDF',
    sending: 'Envoi…',
    resend: 'Renvoyer pour validation',
    send: 'Envoyer au bureau technique pour validation',
  },
  crane3d: {
    loading: 'Chargement…',
  },
}
